import { useState } from "react";
import BioForm from "./BioForm";

export default function BioHero() {
  const [showForm, setShowForm] = useState(false);

  const scrollToNext = () => {
    const el = document.getElementById("como-funciona");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <section id="top" className="relative min-h-screen flex flex-col items-center justify-center px-4 py-20 overflow-hidden">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full glow-orb blur-3xl opacity-40 pointer-events-none"></div>

        <div className="relative z-10 max-w-xl mx-auto text-center">
          {/* Badge */}
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-semibold tracking-widest text-primary-400 mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse-glow"></span>
            BM • KWAI ADS • PERFORMANCE
          </span>

          {/* Logo text */}
          <h1 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl tracking-tight text-foreground-950 mb-4">
            kwai<span className="text-primary-500">.</span>ads
          </h1>

          {/* Copy */}
          <p className="text-lg md:text-xl text-foreground-700 leading-relaxed mb-2">
            Quer rodar no Kwai, mas não tem BM?
          </p>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
            A gente libera sua Business Manager, te ensina a subir a primeira campanha e dá o suporte básico. 
            Se quiser, um gestor dedicado cuida de tudo.
          </p>

          {/* Divider */}
          <div className="w-16 h-px bg-primary-500/40 mx-auto mb-8"></div>

          {/* CTA area */}
          <div className="flex flex-col items-center gap-3">
            {/* Saiba mais bouncing */}
            <button
              onClick={scrollToNext}
              className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-primary-400 hover:text-primary-300 transition-colors animate-bounce-soft cursor-pointer"
            >
              SAIBA MAIS
              <i className="ri-arrow-down-line"></i>
            </button>

            {/* Main CTA — pulsating gradient button, narrower */}
            <button
              onClick={() => setShowForm(true)}
              className="w-72 sm:w-80 inline-flex items-center justify-center gap-2.5 rounded-xl px-6 py-4 text-sm font-bold tracking-wide text-background-50 bg-gradient-to-r from-primary-500 to-accent-500 animate-pulse-glow-btn transition-transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              QUERO MINHA BM
            </button>

            <p className="text-xs text-foreground-500 mt-2">
              Rápido. Direto. Sem burocracia.
            </p>
          </div>

          {/* Mini social proof — more subtle, centered */}
          <div className="mt-10 flex flex-col items-center gap-2 text-foreground-500 text-xs">
            <div className="flex -space-x-1.5">
              <div className="w-6 h-6 rounded-full bg-primary-500/15 border border-background-100 flex items-center justify-center text-[10px] font-bold text-primary-400">1</div>
              <div className="w-6 h-6 rounded-full bg-accent-500/15 border border-background-100 flex items-center justify-center text-[10px] font-bold text-accent-400">2</div>
              <div className="w-6 h-6 rounded-full bg-secondary-500/15 border border-background-100 flex items-center justify-center text-[10px] font-bold text-secondary-400">3</div>
              <div className="w-6 h-6 rounded-full bg-primary-500/10 border border-background-100 flex items-center justify-center text-[10px] font-bold text-primary-300">+</div>
            </div>
            <span className="text-foreground-600">+50 BMs liberadas</span>
          </div>
        </div>
      </section>

      {showForm && <BioForm onClose={() => setShowForm(false)} />}
    </>
  );
}